// =====================================================================
//  Onglet « Généralités » d'une stratégie OTP.
//  Nom, Libellé, Id copiable.
// =====================================================================

import {IDisposableLike} from "../../Tools/Disposable/IDisposableLike";
import {IOtpStrategyModel} from "../../Model/Otp/OtpStrategyModel.js";
import {NotificationHelper} from "../../Helper/NotificationHelper.js";

export class OtpGeneraliteEditor implements IDisposableLike {
    #jqMainContainer: JQuery | undefined;
    #jqFormContainer: JQuery | undefined;
    #model: IOtpStrategyModel;
    #kForm: kendo.ui.Form | undefined;

    constructor(options: IOtpGeneraliteEditorOptions) {
        this.#jqMainContainer = options.jqMainContainer;
        this.#model = options.model;
    }

    public Init = () => {
        this.#buildHtml();
        this.#buildForm();
    };

    #buildHtml = () => {
        this.#jqFormContainer = $("<div></div>")
            .css({padding: "12px", maxWidth: "640px"})
            .appendTo(this.#jqMainContainer);
    };

    #buildForm = () => {
        const formData: any = {
            Nom: this.#model.Nom,
            Libelle: this.#model.Libelle,
            Primarykey: this.#model.Primarykey,
        };

        this.#kForm = this.#jqFormContainer
            .kendoForm({
                formData,
                orientation: "vertical",
                size: "small",
                items: [
                    {field: "Nom", label: "Nom", validation: {required: true}},
                    {
                        field: "Libelle",
                        label: "Libellé",
                        validation: {required: false},
                        editor: "TextArea",
                        editorOptions: {size: "small", rows: 4, length: 800},
                    },
                    {
                        field: "Primarykey",
                        label: "Id",
                        attributes: {"circ-id": "otpStrategyId"},
                        editorOptions: {enable: true, suffixOptions: {icon: "copy"}},
                        validation: {required: false},
                    },
                ],
                change: (e: kendo.ui.FormChangeEvent) => {
                    switch (e.field) {
                        case "Nom":
                            this.#model.Nom = e.value;
                            break;
                        case "Libelle":
                            this.#model.Libelle = e.value;
                            break;
                    }
                },
            })
            .data("kendoForm");

        this.#kForm.element.find(".k-form-buttons").remove();

        const input = this.#kForm.element.find("[circ-id='otpStrategyId']");
        input.prop("disabled", true);
        input.siblings(".k-input-suffix").on("click", () => {
            navigator.clipboard
                .writeText(input.val()?.toString() ?? "")
                .then(() =>
                    NotificationHelper.Instance.success("L'Id a été copié dans le presse-papier"),
                );
        });
    };

    public Dispose = () => {
        if (this.#kForm) this.#kForm.destroy();
        if (this.#jqFormContainer) this.#jqFormContainer.remove();
        if (this.#jqMainContainer) this.#jqMainContainer.empty();
    };
}

export interface IOtpGeneraliteEditorOptions {
    jqMainContainer: JQuery;
    model: IOtpStrategyModel;
}
